<ng-container *transloco="let t; read: 'configuration'">
<div class="p-5">
  <div class="flex justify-between">
    <drdp-title [title]="t('agencies.title')"></drdp-title>
    <span>
      <drdp-btn *drdpCheckPermission="Permission.CreateAgencies" (click)="openModal(undefined, ModalType.Agency)">
        <i class="uil uil-plus"></i>
        {{ t('agencies.addNew') }}
      </drdp-btn>
    </span>
  </div>
  <drdp-container [additionClasses]="'min-h-[44rem]'">
    @if (hasAccessToAll) {
      <drdp-container color="lightBlue">
        <form [formGroup]="searchForm" (ngSubmit)="search()">
          <div class="p-3 flex grid md:grid-cols-5 gap-2 flex-row content-between">
            <ng-container class="contents">
              <div class="col-span-1">
                <label class="font-bold">{{ t('common.searchBy') }}</label>
                <div class="border-b border-black">
                  <input
                    matInput
                    [placeholder]="t('agencies.fields.agencyName')"
                    searchInput="searchInput"
                    formControlName="agencyName"/>
                </div>
              </div>
              <div class="col-span-1">
                <drdp-select-state
                  #stateSelect
                  [initialStateId]="stateId?.value"
                  (state)="handleState($event)">
                </drdp-select-state>
              </div>
              <div class="col-span-1">
                <drdp-select-agency
                  #agencySelect
                  (agency)="handleAgency($event)"
                  [stateId]="stateId?.value"
                  [initialAgencyId]="agencyId?.value"
                  [activeOnly]="false">
                </drdp-select-agency>
              </div>
              <div class="col-span-1">
                <drdp-select-type
                  #typeSelect
                  (type)="handleType($event)"
                  [initialTypeId]="typeId?.value">
                </drdp-select-type>
              </div>
              <div class="col-span-1 md:col-start-5 self-end justify-center md:justify-self-end">
                <drdp-btn type="submit" class="mr-2">{{ t('common.search') }}</drdp-btn>
                <drdp-btn type="button" (click)="onClear()" color="outline">{{ t('common.clear') }}</drdp-btn>
              </div>
            </ng-container>
          </div>
        </form>
      </drdp-container>
    }
    <drdp-add-edit-table
      [dataSource]="dataSource"
      [tableData]="tableData"
      [columns]="tableColumns"
      [isSuperAdmin]="hasAccessToAll"
      (editActionItem)="openModal($event)">
    </drdp-add-edit-table>
  </drdp-container>
  @if (hasAccessToAll) {
    <mat-paginator
      [pageSizeOptions]="pageSizeOptions"
      [pageSize]="pageSize"
      [length]="totalData"
      [pageIndex]="pageIndex"
      (page)="paginateAgency(false)">
    </mat-paginator>
  }
</div>
</ng-container>
